import React, { useState, useRef, useContext } from "react";
import PageHeader from "../pageheader/PageHeader";
import Button from "../material/button/Button";
import Select from "../material/select/Select";
import { HashLoader } from "react-spinners";
import styles from "./UploadExcelResults.module.css";
import uploadResult from "../../asset/image/uploadresult.svg";
import numberOne from "../../asset/image/numberOne.svg";
import numberTwo from "../../asset/image/numberTwo.svg";
import numberThree from "../../asset/image/numberThree.svg";
import line from "../../asset/image/line.svg";
import downloadIcon from "../../asset/icon/download.svg";
import uploadIcon from "../../asset/icon/upload.svg";
import { ModaluploadResults } from "../material/modal/ModaluploadResults";
import ManuOperation from "./navOperationRoom/ManuOperation";
import readXlsxFile from "read-excel-file";
import * as labPersonalApi from "../../service/labPersonalApi";
import { Link, useNavigate } from "react-router-dom";
import excelFile from "../../asset/files/ไฟล์ต้นแบบ.xlsx";
import moment from "moment";
import { RedirectCode400 } from "../RedirectCode400";
import { environment } from "../../config.env";
import { CurrentUserContext } from "../../App";

import Breadcrumb from "../public/breacrumb/breadcrumb";
import Footer from "../footer/Footer";
import HeadBar from "../../component/public/headBar/HeadBar";

const ENDPOINT_DOMAIN = environment.endpoint_domain || "";
const LAB_DATA_IMPORT_MASTER_FILE =
  environment.lab_data_import_master_file || "";

function UploadExcelResults() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [loading, setLoading] = useState(false);

  const inputFileRef = useRef(null);
  const downloadFileRef = useRef(null);

  const [fileName, setFileName] = useState();
  const [file, setFile] = useState(null);
  const [excelDataList, setExcelDataList] = useState(null);

  const nav = useNavigate();

  const inputFileChange = async (event) => {
    // console.log(event);

    if (event) {
      let fileObj = event.target.files && event.target.files[0];
      setFile(fileObj);
      setFileName(fileObj.name);
      readXlsxFile(fileObj).then((rows) => {
        let obj = {};
        let objList = [];

        for (let index = 0; index < rows[0].length; index += 1) {
          let key = rows[0][index];
          obj[key] = "";
        }
        for (let index = 1; index < rows.length; index += 1) {
          let valueObj = {};
          Object.keys(obj).forEach((key, keyIndex) => {
            if (typeof rows[index][keyIndex] === "object") {
              valueObj[key] = moment(rows[index][keyIndex]).format(
                "YYYY-MM-DD",
              );
            } else {
              valueObj[key] = String(rows[index][keyIndex]);
            }
          });
          objList.push(valueObj);
        }
        setExcelDataList(objList);
      });
    }
  };

  const [openModal, setOpenModal] = useState(false);
  const onclickOpenModal = () => {
    setOpenModal(true);
  };

  const importFile = async () => {
    let formData = new FormData();
    formData.append("file", file);

    setLoading(true);
    let res = await labPersonalApi.importLab(formData);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "สำเร็จ" });
        nav("/InputData");
      } else if (
        res["data"]["code"] === 400 &&
        res["data"]["error_list"].length > 0
      ) {
        let text = "";
        let errorList = res["data"]["error_list"];

        for (let index = 0; index < errorList.length; index += 1) {
          let data = errorList[index];
          let col = data["column"];

          text += `แถวที่ ${data["row"]}, คอลัมน์ ${String.fromCharCode(
            64 + col,
          )} ${data["value"]} \n`;
        }
        setIsMessage({ type: "warning", data: text });
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ข้อมูลผลการตรวจ", url: "/inputdata" },

    {
      name: "ขั้นตอนการนำเข้าไฟล์ข้อมูลผลการตรวจ",
      url: "/inputdata/uploadExcelResults",
    },
  ];

  return (
    <>
      {loading && (
        <div style={loadingOverlayStyle}>
          <HashLoader color="#FF9768" size={70} />
          <div
            style={{
              marginTop: "20px",
              color: "#FF9768",
              fontWeight: "600",
              fontSize: "18px",
            }}
          >
            กำลังดำเนินการ กรุณารอสักครู่...
          </div>
        </div>
      )}

      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename="ขั้นตอนการนำเข้าไฟล์ข้อมูลผลการตรวจ" />
        <div className="flex justify-center w-full">
          <div className={styles.cardContainer}>
            <div className={styles.alignImg}>
              <img src={uploadResult} />
            </div>
            <div>
              <div className={styles.container}>
                <div className={styles.alignNumber}>
                  <img src={numberOne} />
                  <img src={line} />
                  <img src={numberTwo} />
                  <img src={line} />
                  <img src={numberThree} />
                </div>
                <div className={styles.alignText}>
                  <div>ดาวน์โหลดไฟล์ต้นแบบการลงข้อมูลที่นี่ นะ</div>
                  <HashLoader
                    loading={false}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      margin: "20px",
                    }}
                    color="#FF9768"
                  />
                  <div
                    onClick={() => {
                      window.open("https://hcode.moph.go.th/code/");
                    }}
                    className="text-[red] md:text-[12px] text-[14px] underline hover:cursor-pointer hover:font-semibold"
                  >
                    ท่านสามารถตรวจสอบรหัสสถานพยาบาล 9 หลัก ได้ที่นี่
                  </div>
                  <div className="text-[red] md:text-[12px] text-[14px] font-[600]">
                    หากไม่พบรหัสสถานพยาบาล กรุณาติดต่อแอดมิน
                  </div>
                  <Link
                    style={{ display: "none" }}
                    ref={downloadFileRef}
                    to={excelFile}
                    target="_blank"
                    download={true}
                  ></Link>
                  <div className={styles.alignButton}>
                    <Button
                      style={{
                        width: 200,
                        background: "#FFFFFF",
                        color: "#ABDFCC",
                      }}
                      onClick={() => {
                        // downloadFileRef.current.click()
                        window.open(
                          `${ENDPOINT_DOMAIN}/doc/${LAB_DATA_IMPORT_MASTER_FILE}`,
                          "_system",
                        );
                      }}
                    >
                      ดาวน์โหลด
                      <img className={styles.imgIcon} src={downloadIcon} />
                    </Button>
                  </div>
                  <div className={styles.marginTwo}>
                    กรอกข้อมูลในไฟล์ต้นแบบตามรูปแบบที่กำหนด โดย
                    ระบุวันเดือนปีหัวข้อการตรวจต้องเป็นไปตามไฟล์ต้นแบบเท่านั้น
                  </div>
                  <div className={styles.marginThree}>อัปโหลดไฟล์</div>
                  <div className={styles.alignButton}>
                    <Button
                      style={{
                        width: 200,
                        background: "#FFFFFF",
                        color: "#ABDFCC",
                      }}
                      onClick={() => {
                        inputFileRef.current.click();
                      }}
                    >
                      อัปโหลดไฟล์
                      <img className={styles.imgIcon} src={uploadIcon} />
                    </Button>
                    <input
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      type={"file"}
                      ref={inputFileRef}
                      onChange={(e) => {
                        inputFileChange(e);
                      }}
                      onClick={(event) => {
                        event.currentTarget.value = null;
                      }}
                      style={{ display: "none" }}
                    ></input>
                  </div>
                  <div>
                    <div className={styles.container}>{fileName}</div>
                  </div>
                </div>
              </div>
              <div className={styles.alignInput}>
                <div style={{ width: "140px", marginTop: "10px" }}>
                  <Button
                    disabled={fileName ? false : true}
                    onClick={onclickOpenModal}
                  >
                    ตกลง
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {openModal ? (
          <>
            <ModaluploadResults
              onClose={() => {
                setOpenModal(false);
              }}
              dataList={excelDataList}
              onSubmit={() => {
                setOpenModal(false);
                importFile();
              }}
            />
          </>
        ) : null}
      </div>
    </>
  );
}

const loadingOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
  backdropFilter: "blur(5px)",
};

export default UploadExcelResults;
